import { render } from "./QuestionSkeleton.vue?vue&type=template&id=4508ce55&scoped=true"
const script = {}

import "./QuestionSkeleton.vue?vue&type=style&index=0&id=4508ce55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4508ce55"]])

export default __exports__